import { getRootDomain } from '../utils/stringUtil';

const MatkaLogo = 'theme/Matka/title.png';
const MatkaIcon = 'theme/Matka/favicon.png';
const Strike46Loader = 'theme/Strike46/Loader.gif';

const Sara777Logo = 'theme/Sara777/title.png';
const Sara777Icon = 'theme/Sara777/favicon.png';
const Sara777Loader = 'theme/Sara777/Loader.gif';

const btxLogo = 'theme/btx/title.png';
const btxIcon = 'theme/btx/favicon.png';
const btxLoader = 'theme/btx/Loader.gif';
export interface WhitelabelEnvDTO {
  FOLDER_NAME: string;
  BRAND_NAME: string;
  BRAND_DOMAIN: string;
  logo: any;
  favicon: any;
  Loader: any;
  telegramBot?: string;
  skins?: Array<{
    label: string;
    domain: string;
    disabled?: boolean;
  }>;
}

const matkaEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Matka',
  BRAND_NAME: 'MatkaDemo',
  BRAND_DOMAIN: 'demo.matkaadda.com',
  logo: MatkaLogo,
  favicon: MatkaIcon,
  Loader: Strike46Loader,
  telegramBot: 'https://t.me/matkademobot',
};

const sara777Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Sara777',
  BRAND_NAME: 'Sara777',
  BRAND_DOMAIN: 'sara777matka.vip',
  logo: Sara777Logo,
  favicon: Sara777Icon,
  Loader: Sara777Loader,
  telegramBot: 'https://t.me/sara777matkabot',
};


const btxEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'btx',
  BRAND_NAME: 'btx',
  BRAND_DOMAIN: 'btx.matkaid.site',
  logo: btxLogo,
  favicon: btxIcon,
  Loader: btxLoader,
};

export const WhitelabelEnvMap = {
  'btx.matkaid.site': btxEnvs,
  localhost: matkaEnvs,

  // Stage domains
  'stage-matka.strike46.com': matkaEnvs,
  'demo.matkaadda.com': matkaEnvs,
  'sara777matka.vip': sara777Envs,
};

export function getEnvVariable(domain: string, variable: keyof WhitelabelEnvDTO): any {
  const cleanDomain = domain.replace(/www./g, '');
  const env = WhitelabelEnvMap[cleanDomain as keyof typeof WhitelabelEnvMap];

  if (!env) {
    throw new Error(`Domain '${cleanDomain}' not found in WhitelabelEnvMap`);
  }

  return env[variable];
}

let cachedLoader: string | null = null;
let isLoaderInitialized = false;

export const getLoader = (domain: string): string => {
  if (isLoaderInitialized && cachedLoader !== null) {
    return cachedLoader;
  }

  const loader = getEnvVariable(domain, 'Loader');
  cachedLoader = typeof loader === 'string' ? loader : String(loader);
  isLoaderInitialized = true;

  return cachedLoader;
};

export const Loader = (domain: string) => getLoader(domain);

export const getTelegramBotLink = (domain: string): string => {
  const cleanDomain = domain.replace(/www./g, '');
  const env = WhitelabelEnvMap[cleanDomain as keyof typeof WhitelabelEnvMap];

  if (!env || !env.telegramBot) {
    // Fallback to default Strike46 bot if no specific bot is configured
    return 'https://t.me/matkademobot';
  }

  return env.telegramBot;
};